var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio-button",class:{'radio-button--disabled': _vm.opacity}},[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.value === _vm.code,"value":_vm.code},on:{"change":_vm.change}}),_c('span',{staticClass:"radio-button__status"}),_c('p',{staticClass:"radio-button__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }